import React, {useEffect, useState} from 'react';
import "./SearchChannel.sass";
import {
    FiFilter,
    FiSettings,
    FiLayers
} from 'react-icons/fi';
import { AiOutlineUsergroupAdd, AiOutlineUserAdd, AiOutlinePlus } from "react-icons/ai"
import {useGlobal} from "reactn";
import Actions from "../../../constants/Actions";
import {useDispatch, useSelector} from "react-redux";
import getChannels from "../../../actions/getChannels";
import icons from "../../../assets";
import FilterRoom from "./FilterRoom";
import ModalSearchZalo from "./ModalSearchZalo";
import ModalAddOaGroup from "./ModalAddOaGroup";
import ModalLoginQrCodeZalo from "./ModalLoginQrCodeZalo";
import SettingModal from "./SettingModal";
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Select, Tooltip, List, Popover } from 'antd';
import {
    QrcodeOutlined,
  } from '@ant-design/icons';

const SelectChannel = () => {
    const { t } = useTranslation();
    const channels = useSelector(state => state.io.channels);
    const socialActive = useGlobal('socialActive')[0];
    const setPageCurrentRoom = useGlobal('pageCurrentRoom')[1];
    const dispatch = useDispatch();
    const [countFilter, setCountFilter] = useState(0);
    const [showDialogFilter, setShowDialogFilter] = useState(false);
    const [showModalSearchZalo, setShowModalSearchZalo] = useState(false);
    const [showModalCreateGroup, setShowModalCreateGroup] = useState(false);
    const [showModalSetting, setShowModalSetting] = useState(false);
    const [showModalQrCode, setShowModalQrCode] = useState(false);
    const history = useHistory();

    //Filter
    const [roomFilter, setRoomFilter] = useGlobal('roomFilter');
    const chatMode = useGlobal('chatMode')[0];
    const Setting = useGlobal('settings')[0];

    useEffect(() => {
        if(chatMode === 'server'){
            getChannels(socialActive).then(res => dispatch({type: Actions.SET_CHANNELS, channels: res.data.channels})).catch(err => console.log(err));
        }
    }, [socialActive, chatMode]);

    useEffect(() => {
        countRoomFilter()
    }, [roomFilter]);

    const countRoomFilter = () => {
        let count = 0;
        if(roomFilter.linked_status !== 'all') count++;
        if(roomFilter.status !== 'all') count++;
        if(roomFilter.tag_ids.length > 0) count++;
        if(roomFilter.mapping_id) count++;
        if(roomFilter.is_group) count++;
        setCountFilter(count);
    }

    const customOption = (channel) => {
        return (
            <div className="custom-channel-name">
                <div className="avatar-channel">
                    <img src={getAvatarSocial(channel)} alt="" />
                </div>
                <span>{channel.nameApp}</span>
            </div>
        )
    }

    const getAvatarSocial = (channel) => {
        if(channel.avatar){
            return channel.avatar;
        }

        if(channel.source === 'facebook'){
            return `https://graph.facebook.com/v21.0/${channel.socialChanelId}/picture`;
        }
        
        if(channel.source === 'zalo'){
            return icons.Zalo;
        }
        
        return icons.ClientChat;
    }

    let channelLists = channels.map(channel => ({
        value: channel._id, 
        label: customOption(channel)
    }));

    channelLists.unshift({
        value: "", 
        label: customOption({nameApp: t('all_channel'), avatar: icons.Home})
    });

    const handleClickShow = () => {
        setShowDialogFilter(current => !current);
    }

    const handleChangeChannel = (channelId) => {
        setRoomFilter({...roomFilter, channel_id: channelId});
        setPageCurrentRoom(1);
    };

    const ContentListAction = () => {
        return (
            <List>
                {Setting && Setting.enable_zalo_personal === 1 && (
                    <List.Item style={{cursor: 'pointer'}} onClick={() => setShowModalSearchZalo(true)}><AiOutlineUserAdd size={23} color={'#0067ac'}/> Thêm bạn Zalo</List.Item>
                )}
                <List.Item style={{cursor: 'pointer'}} onClick={() => setShowModalCreateGroup(true)}><AiOutlineUsergroupAdd size={23} color={'#0067ac'}/> Tạo nhóm Zalo</List.Item>
                <List.Item style={{cursor: 'pointer'}} onClick={() => history.push('/campaign/message-notification')}><FiLayers size={22} color={'#0067ac'}/> Cấu hình gửi tin</List.Item>
                <List.Item style={{cursor: 'pointer'}} onClick={() => setShowModalSetting(true)}><FiSettings size={22} color={'#0067ac'}/> Cấu hình chung</List.Item>
            </List>
        )
    }


    return (
        <div className="select-wrap uk-flex select-bar uk-flex-between">
            <div className="select-channel">
                <Select
                    defaultValue=""
                    value={roomFilter.channel_id}
                    onChange={handleChangeChannel}
                    placeholder={`${t('choose_channel')}...`}
                    options={channelLists}
                />
            </div>
            {(Setting && Setting.enable_zalo_personal === 1) && (
                <div className="qr-code" onClick={() => setShowModalQrCode(true)}>
                    <Tooltip placement="bottom" title={`Đăng nhập Zalo QR Code`}>
                        <QrcodeOutlined style={{ color: '#0067ac', fontSize: '21px', marginTop: '2px'}} />
                    </Tooltip>
                </div>
            )}
            <div className="add-group">
                <Popover 
                    content={<ContentListAction />} 
                    title="" 
                    placement="bottom"
                    trigger="hover"
                >
                    <AiOutlinePlus size={25} color={'#0067ac'}/>
                </Popover>

            </div>
            <div className="selection-tag">
                <Tooltip placement="bottom" title={`Lọc cuộc trò chuyện`}>
                    <div className="selection-tag-icon" onClick={() => handleClickShow()}>
                        <FiFilter size={25} color={'#0067ac'}/>
                        {countFilter > 0 && <span className="filtered-count">{countFilter}</span>}
                    </div>
                </Tooltip>
            </div>
            {showDialogFilter && <FilterRoom setShowDialogFilter={setShowDialogFilter}/>}
            {showModalSearchZalo && <ModalSearchZalo showModal={showModalSearchZalo} setShowModal={setShowModalSearchZalo}/>}
            {showModalCreateGroup && <ModalAddOaGroup showModal={showModalCreateGroup} setShowModal={setShowModalCreateGroup}/>}
            {showModalQrCode && <ModalLoginQrCodeZalo showModal={showModalQrCode} setShowModal={setShowModalQrCode}/>}
            {showModalSetting && <SettingModal showModalSetting={showModalSetting} setShowModalSetting={setShowModalSetting} />}
        </div>
    );
}

export default SelectChannel;
